export function common() {
  const header = document.getElementById("js-header");

  if (!header) return; // 要素が存在しない場合は処理を終了

  const headerScroll = () => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 1 && window.innerWidth > 768) {
        header.classList.add("is-scroll");
      } else {
        header.classList.remove("is-scroll");
      }
    });
  };

  headerScroll();
}

// フォーム ファイル部分
// document.addEventListener("DOMContentLoaded", function () {
//   const input = document.getElementById("fileUpload");
//   const fileNameDisplay = document.getElementById("fileName");

//   input.addEventListener("change", function () {
//     if (input.files.length > 0) {
//       const fileList = Array.from(input.files)
//         .map(
//           (file) => `<div class="c-fileUpload__filenameItem">${file.name}</div>`
//         )
//         .join("");

//       fileNameDisplay.innerHTML = fileList;
//     } else {
//       fileNameDisplay.textContent = "ファイルを選択してください";
//     }
//   });
// });


// SPサイズ fixボタン c-mv過ぎてから表示
document.addEventListener("DOMContentLoaded", function () {
  const mv = document.querySelector(".c-mv");
  const fix = document.querySelector(".c-fix._sp");

  if (!mv || !fix) {
    console.warn("要素が見つかりません：.c-mv または .c-fix");
    return;
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      const isVisible = !entry.isIntersecting;
      fix.classList.toggle("is-visible", isVisible);
    },
    {
      threshold: 0,
      rootMargin: "0px 0px -30% 0px",
    }
  );

  observer.observe(mv);
});
